<div class="robot-chat-test-container" testId="robot-chat-test-container">
  <div class="chat-header" testId="robot-chat-test-header">
    <div class="header-info">
      <h3 class="title" testId="robot-chat-test-title">{{ 'robot-chat.test-title' | i18n }}</h3>
      <span class="robot-info" testId="robot-chat-test-robot-name">
        {{ 'robot-chat.robot-name' | i18n }}: {{ modalData.robotName || i18n.fanyi('servicenumber.robot.default-robot-name') }}
      </span>
    </div>
    <div class="header-actions">
      <button nz-button nzType="default" nzSize="small" (click)="clearChat()" [disabled]="sending" testId="robot-chat-test-clear-button">
        <i nz-icon nzType="delete"></i>
        {{ 'robot-chat.clear-chat' | i18n }}
      </button>
      <button nz-button nzType="default" nzSize="small" (click)="close()" testId="robot-chat-test-close-button">
        <i nz-icon nzType="close"></i>
        {{ 'common.close' | i18n }}
      </button>
    </div>
  </div>

  <div class="chat-messages" #messagesContainer testId="robot-chat-test-messages">
    <div
      *ngFor="let msg of messages; let i = index"
      class="message-wrapper"
      [class.user-message]="msg.role === 'user'"
      [class.assistant-message]="msg.role === 'assistant'"
      [attr.data-testid]="'robot-chat-test-message-' + i"
    >
      <div class="message-bubble">
        <div class="message-content" *ngIf="!msg.loading">{{ msg.content }}</div>
        <div class="message-loading" *ngIf="msg.loading">
          <nz-spin nzSimple [nzSize]="'small'" />
          <span>{{ 'robot-chat.thinking' | i18n }}</span>
        </div>
        <div class="message-time">{{ msg.timestamp | date: 'HH:mm:ss' }}</div>
      </div>
    </div>

    <div *ngIf="messages.length === 0" class="empty-state" testId="robot-chat-test-empty">
      <i nz-icon nzType="message" nzTheme="outline"></i>
      <p>{{ 'robot-chat.empty-message' | i18n }}</p>
    </div>
  </div>

  <div class="chat-quick-replies" *ngIf="latestQuickReplies.length" testId="robot-chat-test-quick-replies">
    <button
      *ngFor="let reply of latestQuickReplies; let i = index"
      class="quick-reply"
      nz-button
      nzType="default"
      nzSize="small"
      [disabled]="sending"
      (click)="sendQuickReply(reply)"
      [testId]="'robot-chat-test-quick-reply-' + i"
    >
      {{ reply }}
    </button>
  </div>

  <div class="chat-input-area" testId="robot-chat-test-input-area">
    <textarea
      #messageInput
      nz-input
      [(ngModel)]="inputMessage"
      [placeholder]="'robot-chat.input-placeholder' | i18n"
      [nzAutosize]="{ minRows: 1, maxRows: 4 }"
      (keydown)="handleKeyPress($event)"
      [disabled]="sending"
      testId="robot-chat-test-input"
    ></textarea>
    <button
      nz-button
      nzType="primary"
      (click)="sendMessage()"
      [disabled]="!inputMessage.trim() || sending"
      [nzLoading]="sending"
      testId="robot-chat-test-send-button"
    >
      <i nz-icon nzType="send" *ngIf="!sending"></i>
      {{ 'robot-chat.send' | i18n }}
    </button>
  </div>
</div>
